module.exports = __webpack_public_path__ + "static/media/crown.b52421cb.png";